export type FetchWithDefaultHeaders = typeof global.fetch & {
  setDefaultHeader: (key: string, value?: string) => void;
};

export type FetchWithRequestInterceptor = typeof global.fetch & {
  setRequestInterceptor: (
    interceptor?: (url: string, init: RequestInit) => RequestInit,
  ) => void;
};

const fetch = ((...params: Parameters<typeof global.fetch>) => {
  // Make sure bound context of fetch doesn't change.
  return global.fetch(...params);
}) as FetchWithDefaultHeaders & FetchWithRequestInterceptor;

// Expose the setter from the global shim.
fetch.setDefaultHeader = (
  global.fetch as FetchWithDefaultHeaders
).setDefaultHeader;

fetch.setRequestInterceptor = (
  global.fetch as FetchWithRequestInterceptor
).setRequestInterceptor;

export default fetch;
